import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import axios from "axios";
import { Button, TextField, Modal, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../components/editmodal.css"
import { toast } from "react-toastify";
import { setDevice } from "../redux/slices/deviceSlice";


const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "70vh",
    overflowY: "auto",
    width: 400,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    outline: "none",
    borderRadius: 5,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  label: {
    fontWeight: "bold",
  },
  fieldContainer: {
    display: "flex",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "7%",
    marginTop: "20px",
  },
}));

const EditDeviceForm = ({ selectedItemId, deviceData, handleClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const oldDeviceData = useSelector((state) => state.device);
  const [formData, setFormData] = useState({
    name: deviceData.name,
    serial: deviceData.serial,
    ipAddress: deviceData.ipAddress,
    portNumber: deviceData.portNumber,
    model: deviceData.model,
    type: deviceData.type,
  });

  useEffect(() => {
    const selectedDevice = deviceData.find(
      (device) => device.id === selectedItemId
    );

    if (selectedDevice) {
      setFormData({
        name: selectedDevice.name,
        serial: selectedDevice.serial,
        ipAddress: selectedDevice.ipAddress,
        portNumber: selectedDevice.portNumber,
        model: selectedDevice.model,
        type: selectedDevice.type,
      });
    }
  }, [selectedItemId, deviceData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const requestBody = {
      ...formData,
      id: selectedItemId,
    };

    const api = localStorage.getItem("api");
    axios
      .post(api + `/device`, requestBody, headers)
      .then((response) => {
        const editedDevice = response.data[0];
        const index = oldDeviceData.device.findIndex(
          (device) => device.id === editedDevice.id
        );

        if (index !== -1) {
          const updatedDeviceData = [...oldDeviceData.device];
          updatedDeviceData[index] = editedDevice;
          dispatch(setDevice(updatedDeviceData));
        } else {
          const updatedDeviceData = [...oldDeviceData.device, editedDevice];
          dispatch(setDevice(updatedDeviceData));
        }
        toast.success("Updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        handleClose();
      })
      .catch((error) => {
        console.error("Error updating device:", error);
        toast.error("Cannot be updated!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <>
      <Modal open={true} onClose={handleClose}>
        <Box className="centered-box">
          <form onSubmit={handleSubmit} className={classes.formContainer}>
            <h3> Edit Device </h3>

            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("Name:", true)}
              <TextField
                required
                id="name"
                name="name"
                size="small"
                variant="outlined"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("Serial:", true)}
              <TextField
                required
                id="serial"
                disabled
                name="serial"
                size="small"
                variant="outlined"
                value={formData.serial}
                onChange={handleChange}
              />
            </div>

            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("IP Address:", true)}
              <TextField
                required
                id="ipAddress"
                name="ipAddress"
                size="small"
                variant="outlined"
                value={formData.ipAddress}
                onChange={handleChange}
              />
            </div>

            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("Port Number:", true)}
              <TextField
                required
                id="portNumber"
                name="portNumber"
                size="small"
                variant="outlined"
                value={formData.portNumber}
                onChange={handleChange}
              />
            </div>

            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("Model:", true)}
              <TextField
                required
                id="model"
                name="model"
                size="small"
                disabled
                variant="outlined"
                value={formData.model}
                onChange={handleChange}
              />
            </div>

            <div className={classes.fieldContainer}>
              {getLabelWithAsterisk("Type:", true)}
              <TextField
                required
                id="type"
                name="type"
                size="small"
                disabled
                variant="outlined"
                value={formData.type}
                onChange={handleChange}
              />
            </div>

            <div className={classes.buttonContainer}>
              <Button
                style={{ textTransform: "none" }}
                type="submit"
                variant="contained"
                color="primary"
                size="small"
              >
                Update
              </Button>
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="primary"
                onClick={handleClose}
                size="small"
              >
                Cancel
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default EditDeviceForm;
